import { render, staticRenderFns } from "./single-choice.vue?vue&type=template&id=89317b86&scoped=true&"
import script from "./single-choice.vue?vue&type=script&lang=js&"
export * from "./single-choice.vue?vue&type=script&lang=js&"
import style0 from "./single-choice.vue?vue&type=style&index=0&id=89317b86&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89317b86",
  null
  
)

component.options.__file = "single-choice.vue"
export default component.exports